// Web shim for react-native-image-picker using HTML file input

export function launchImageLibrary(options, callback) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = options?.mediaType === 'video' ? 'video/*' : 'image/*';

  input.onchange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      if (callback) callback({ didCancel: true });
      return;
    }

    const uri = URL.createObjectURL(file);
    const result = {
      assets: [
        {
          uri,
          type: file.type,
          fileName: file.name,
          fileSize: file.size,
          width: options?.maxWidth || undefined,
          height: options?.maxHeight || undefined,
          _file: file, // keep reference for FormData
        },
      ],
    };

    if (callback) {
      callback(result);
    }
  };

  input.click();

  // Return a promise as well for async usage
  return new Promise((resolve) => {
    const originalOnChange = input.onchange;
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) {
        const result = { didCancel: true };
        if (callback) callback(result);
        resolve(result);
        return;
      }

      const uri = URL.createObjectURL(file);
      const result = {
        assets: [
          {
            uri,
            type: file.type,
            fileName: file.name,
            fileSize: file.size,
            _file: file,
          },
        ],
      };

      if (callback) callback(result);
      resolve(result);
    };
  });
}

export function launchCamera(options, callback) {
  // Fallback to image library on web
  return launchImageLibrary(options, callback);
}
